import { makeAutoObservable } from 'mobx';

class SignatureViewModel {
  annotation;
  modalOpen;
  signatureData;

  constructor(annotation) {
    makeAutoObservable(this);

    this.annotation = annotation;
    this.modalOpen = false;
  }

  get isEmpty() {
    return !this.signatureData;
  }

  get isValid() {
    return !this.isEmpty;
  }
}

export default SignatureViewModel;
